import { endpoints } from "../config";
import { deleteData, getData, postData, putData } from "./api-utils";

export const getNews = async () => {
  return await getData(endpoints.news);
};
export const postNews = async (values) => {
  return await postData(endpoints.news, values);
};
export const updateNews = async (id, values) => {
  return await putData(endpoints.news + "/" + id, values);
};
export const deleteNews = async (id) => {
  return await deleteData(endpoints.news + "/" + id);
};

export const getNewsTheme = async () => {
  return await getData(endpoints.newsCategory);
};
export const postNewsTheme = async (values) => {
  return await postData(endpoints.newsCategory, values);
};
export const updateNewsTheme = async (id, values) => {
  return await putData(endpoints.newsCategory + "/" + id, values);
};
export const deleteNewsTheme = async (id) => {
  return await deleteData(endpoints.newsCategory + "/" + id);
};

export const postNewsToTheme = async (newsId, themeId) => {
  return await postData(endpoints.newsToCategory, { newsId, themeId });
};
export const deleteNewsToTheme = async (newsId, categoryId) => {
  return await deleteData(
    endpoints.newsToCategory + `?newsId=${newsId}&categoryId=${categoryId}`
  );
};
